export default {
  title: "Einladung",
  description: "Sie wurden eingeladen, an einer Veranstaltung mitzuarbeiten",
  status: {
    pending: "Ausstehend",
    accepted: "Angenommen",
    declined: "Abgelehnt",
    expired: "Abgelaufen"
  },
  resourceTypes: {
    budget: "Budget",
    guests: "Gäste",
    tasks: "Aufgaben",
    timeline: "Zeitplan",
    vendors: "Anbieter",
    events: "Veranstaltungen"
  },
  accessLevels: {
    view: "Nur anzeigen",
    edit: "Bearbeiten",
    manage: "Vollständige Verwaltung"
  },
  actions: {
    accept: "Annehmen",
    decline: "Ablehnen"
  },
  accessLevel: "Zugriffsebene",
  expiresAt: "Läuft ab am",
  invitedBy: "Eingeladen von",
  unknownUser: "Unbekannter Benutzer",
  success: {
    accepted: "Einladung erfolgreich angenommen",
    declined: "Einladung abgelehnt"
  },
  errors: {
    invalidToken: "Ungültiger Einladungstoken",
    notFound: "Einladung nicht gefunden",
    expired: "Diese Einladung ist abgelaufen",
    accept: "Fehler beim Annehmen der Einladung",
    decline: "Fehler beim Ablehnen der Einladung",
    loadInvitation: "Fehler beim Laden der Einladung",
    pendingInvitation: "Fehler beim Überprüfen ausstehender Einladungen"
  },
  landing: {
    welcome: "Willkommen, {{name}}!",
    welcomeGeneric: "Geteilter Zugriff",
    subtitle: "Geben Sie Ihre E-Mail ein, um auf freigegebene Ressourcen zuzugreifen",
    subtitleAuthenticated: "Sie wurden zur Zusammenarbeit an dieser Veranstaltung eingeladen.",
    confirmIdentity: "Bestätigen Sie Ihre Identität, um auf den sicheren Bereich zuzugreifen, der reserviert ist für",
    emailLabel: "E-Mail-Adresse",
    emailPlaceholder: "deine@email.com",
    emailHelp: "Verwenden Sie die E-Mail-Adresse, mit der Sie die Einladung erhalten haben",
    submitButton: "Zugang zum Bereich",
    validating: "Überprüfung...",
    securityTitle: "Sicherheitsinfo",
    securityPoint1: "Dieser Link ist eindeutig und sicher",
    securityPoint2: "Der Zugriff ist streng auf die eingeladene E-Mail beschränkt",
    securityPoint3: "Keine Kontoerstellung erforderlich",
    errorToken: "Fehlendes Freigabe-Token in der URL",
    errorValidation: "Ungültiger Link oder falsche E-Mail. Überprüfen Sie, ob Sie die richtige E-Mail-Adresse verwenden.",
    errorGeneric: "Bei der Überprüfung ist ein Fehler aufgetreten"
  }
};
